<script>
    let y;
    export let height;
    export let handleClickNav;
    export let selected;
    export let subSelection;
</script>

<svelte:window bind:scrollY={y}/>

<div class="nav-container sticky-top">
    <nav class="navbar navbar-expand-lg navbar-dark sticky-top center-content col-8" style="margin-left: -15px;padding-right: 0;">
        {#if true}
            <span class="navbar-brand clickable" on:click={handleClickNav('home')} style="opacity: {selected === "home" ? y/height : 1}"><img class="img-logo" src="./img/logo-CVS-intro.svg" alt=""></span>
        {/if}
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse width-100" id="collapsibleNavbar">
            <ul class="navbar-nav width-100">
                <li class="nav-item dropdown">
                    <span class="nav-link dropdown-toggle clickable {selected == 'about' ? 'selected-nav' : ''}" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    CONOCE LA CVS
                    </span>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <span class="dropdown-item clickable {subSelection == 0 && selected == 'about' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('about',0)}>DEFINICIÓN Y OBJETIVO</span>
                        <span class="dropdown-item clickable {subSelection == 1 && selected == 'about' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('about',1)}>¿QUÉ TIPOS DE VIVIENDAS SE CERTIFICAN?</span>
                        <span class="dropdown-item clickable {subSelection == 2 && selected == 'about' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('about',2)}>CARACTERÍSTICAS DE UNA VIVIENDA SUSTENTABLE</span>
                        <span class="dropdown-item clickable {subSelection == 3 && selected == 'about' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('about',3)}>BENEFICIOS</span>
                        <span class="dropdown-item clickable {subSelection == 4 && selected == 'about' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('about',4)}>QUIÉNES SOMOS</span>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <span class="nav-link dropdown-toggle clickable {selected == 'info' ? 'selected-nav' : ''}" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    INFORMACIÓN TÉCNICA
                    </span>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <span class="dropdown-item clickable {subSelection == 0 && selected == 'info' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('info',0)}>CATEGORÍAS</span>
                        <span class="dropdown-item clickable {subSelection == 1 && selected == 'info' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('info',1)}>NIVELES DE CERTIFICACIÓN</span>
                        <span class="dropdown-item clickable {subSelection == 2 && selected == 'info' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('info',2)}>RELACIÓN CON CEV Y CES</span>
                        <span class="dropdown-item clickable {subSelection == 3 && selected == 'info' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('info',3)}>ACREDITACIÓN DE ASESORES PARA LA CERTIFICACIÓN</span>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <span class="nav-link dropdown-toggle clickable {selected == 'certification' ? 'selected-nav' : ''}" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    PROCESO DE CERTIFICACIÓN
                    </span>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <span class="dropdown-item clickable {subSelection == 0 && selected == 'certification' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('certification',0)}>ETAPAS</span>
                        <span class="dropdown-item clickable {subSelection == 1 && selected == 'certification' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('certification',1)}>PROCESO</span>
                        <span class="dropdown-item clickable {subSelection == 2 && selected == 'certification' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('certification',2)}>PLAZOS DE REVISIÓN</span>
                        <span class="dropdown-item clickable {subSelection == 3 && selected == 'certification' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('certification',3)}>COSTOS ASOCIADOS</span>
                    </div>
                </li>
                <li class="nav-item dropdown more-visible">
                    <span class="nav-link dropdown-toggle clickable {selected == 'register' || selected == 'downloads' ? 'selected-nav' : ''}" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    MÁS
                    </span>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <span class="dropdown-item clickable {subSelection == 0 && selected == 'register' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('register',0)}>REGISTRO</span>
                        <span class="dropdown-item clickable {subSelection == 1 && selected == 'downloads' ? 'selected-dropdown-item' : ''}" on:click={handleClickNav('downloads',1)}>DESCARGAS</span>
                    </div>
                </li>
                <li class="nav-item less-visible {selected == 'register' ? 'selected-nav' : ''}">
                    <span class="nav-link clickable lateral-margin" on:click={handleClickNav('register', 0)}>REGISTRO</span>
                </li>
                <li class="nav-item less-visible {selected == 'downloads' ? 'selected-nav' : ''}">
                    <span class="nav-link clickable lateral-margin" on:click={handleClickNav('downloads', 0)}>DESCARGAS</span>
                </li>
                <li class="nav-item {selected == 'news' ? 'selected-nav' : ''}">
                    <span class="nav-link clickable lateral-margin" on:click={handleClickNav('news', 0)}>NOTICIAS</span>
                </li>
                <li class="nav-item plataform-button">
                    <a href="https://plataforma.cvschile.cl" class="nav-link clickable"><span class="nav-link-plataform clickable">PLATAFORMA</span></a>
                </li>
            </ul>
        </div>
    </nav>
</div>

<style>

    .dropdown-item{
        color: #00A19A;
        font-size: 19px;
    }

    .dropdown-item:hover{
        background-color: #00A19A;
        color: white;
    }

    .selected-dropdown-item{
        background-color: #00A19A;
        color: white;
    }

    .navbar-brand{
        position: absolute;
        left: 0;
    }

    .width-100{
        width: 100%;
    }

    .navbar-nav{
        justify-content: space-between;
    }

    .plataform-button:hover{
        background-color: white;
        border: 2px solid #93C126;
        color: #93C126 !important;
    }

    .plataform-button:hover .nav-link-plataform{
        color: #93C126 !important;
    }

    @media (max-width: 768px) {
        .lateral-margin{
            margin:0 5px;
        }
    }

    @media (max-width: 767px) {
        .img-logo{
            margin-left:25px;
        }
    }

    @media (min-width: 1400px){
        .more-visible{
            display: none;
        }
    }

    @media (max-width: 1400px){
        .less-visible{
            display: none;
        }
    }

    @media (max-width: 992px){
        .more-visible{
            display: none;
        }
        .less-visible{
            display: block;
        }
    }

    @media (max-width: 321px) {
        .img-logo{
            height: 50px;
            width: 55px;
        }
    }



</style>
